const Location = (props) => (
  <svg
    width={30}
    height={30}
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.9999 28.4505C13.1499 28.4505 11.2874 27.7505 9.83735 26.363C6.14985 22.813 2.07485 17.1505 3.61235 10.413C4.99985 4.30049 10.3374 1.56299 14.9999 1.56299C14.9999 1.56299 14.9999 1.56299 15.0124 1.56299C19.6749 1.56299 25.0124 4.30049 26.3999 10.4255C27.9249 17.163 23.8499 22.813 20.1624 26.363C18.7124 27.7505 16.8499 28.4505 14.9999 28.4505ZM14.9999 3.43799C11.3624 3.43799 6.68735 5.37549 5.44985 10.8255C4.09985 16.713 7.79985 21.788 11.1499 25.0005C13.3124 27.088 16.6999 27.088 18.8624 25.0005C22.1999 21.788 25.8999 16.713 24.5749 10.8255C23.3249 5.37549 18.6374 3.43799 14.9999 3.43799Z"
      fill="currentColor"
    />
    <path
      d="M13.4375 17.1873C13.2 17.1873 12.9625 17.0998 12.775 16.9123L10.9 15.0373C10.5375 14.6748 10.5375 14.0748 10.9 13.7123C11.2625 13.3498 11.8625 13.3498 12.225 13.7123L13.4375 14.9248L17.775 10.5873C18.1375 10.2248 18.7375 10.2248 19.1 10.5873C19.4625 10.9498 19.4625 11.5498 19.1 11.9123L14.1 16.9123C13.9125 17.0998 13.675 17.1873 13.4375 17.1873Z"
      fill="currentColor"
    />
  </svg>
);
export default Location;
